export const saveUser = userInfo => {
  localStorage.setItem("user_contact", JSON.stringify(userInfo))
}

export const getUser = () => {
  try {
    const userInfo = JSON.parse(localStorage.getItem("user_contact"))
    if (userInfo) {
      return userInfo
    }
  } catch (err) {}

  return {}
}
